var map = {
	"./default.jpg": "951a",
	"./default_admin.png": "12f3",
	"./default_icon.png": "a65b",
	"./default_user.png": "624d",
	"./dots.png": "fcb2",
	"./logo.jpg": "17be",
	"./logo.png": "9d64",
	"./logo2.png": "dd88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";